export const handlingEquipmentResources = {
  fr: {
    module: "Moyens de manutention", moduleShort: "Moyens",
    searchPlaceholder: "Moyen, mission, utilisateur…",
    parkReturn: "Retour physique au parc",
    parkReturnHelp: "Scannez l’identifiant du moyen après la fin de sa mission pour le rendre disponible.",
    state: "État des moyens",
    counts: { available: "{{count}} disponible", available_other: "{{count}} disponibles", engaged: "{{count}} engagé", engaged_other: "{{count}} engagés" },
    types: { ROLL: "Roll", TROLLET: "Trollet de livraison", PALLET_TRUCK: "Transpalette", FORKLIFT: "Chariot élévateur" },
    statuses: { AVAILABLE: "Disponible", ASSIGNED: "Affecté", IN_USE: "En utilisation", MAINTENANCE: "Maintenance", OUT_OF_SERVICE: "Hors service" },
    activities: { PICKING_WAVE: "Vague de picking", PICKING_DIRECT: "Picking direct", PUTAWAY: "Mise en stock", DELIVERY: "Livraison" },
    labels: {
      capacityWarehouse: "{{type}} · capacité {{capacity}} · entrepôt {{warehouse}}",
      handlingUnits: "HU {{numbers}}", notTaken: "non encore pris en charge",
      identifier: "Identifiant du moyen"
    },
    scan: { return: "Scanner le moyen de retour", placeholder: "ROLL-001, TRL-001, TPAL-001…" },
    actions: { release: "Libérer", releaseEquipment: "Libérer le moyen", scan: "Scanner un moyen", scanShort: "Scanner", select: "Sélectionner un moyen" },
    permissions: { readOnly: "Vous pouvez consulter les moyens, mais vous n’êtes pas autorisé à les libérer." },
    success: { available: "{{identifier}} est maintenant disponible." },
    errors: { load: "Impossible de charger les moyens de manutention.", release: "Libération du moyen impossible." },
    dialog: { return: "Scanner le moyen de retour" },
    diagnostics: { return: "Retour d’un moyen au parc", view: "Consultation des moyens" }
  },
  en: {
    module: "Handling equipment", moduleShort: "Equipment",
    searchPlaceholder: "Equipment, mission, user…",
    parkReturn: "Physical return to equipment park",
    parkReturnHelp: "Scan the equipment identifier after its mission to make it available again.",
    state: "Equipment status",
    counts: { available: "{{count}} available", available_other: "{{count}} available", engaged: "{{count}} engaged", engaged_other: "{{count}} engaged" },
    types: { ROLL: "Roll", TROLLET: "Delivery Trolley", PALLET_TRUCK: "Pallet truck", FORKLIFT: "Forklift" },
    statuses: { AVAILABLE: "Available", ASSIGNED: "Assigned", IN_USE: "In use", MAINTENANCE: "Maintenance", OUT_OF_SERVICE: "Out of service" },
    activities: { PICKING_WAVE: "Picking wave", PICKING_DIRECT: "Direct picking", PUTAWAY: "Put-away", DELIVERY: "Delivery" },
    labels: {
      capacityWarehouse: "{{type}} · capacity {{capacity}} · warehouse {{warehouse}}",
      handlingUnits: "HU {{numbers}}", notTaken: "not yet taken over",
      identifier: "Equipment identifier"
    },
    scan: { return: "Scan returned equipment", placeholder: "ROLL-001, TRL-001, TPAL-001…" },
    actions: { release: "Release", releaseEquipment: "Release equipment", scan: "Scan equipment", scanShort: "Scan", select: "Select equipment" },
    permissions: { readOnly: "You can view equipment, but you are not authorized to release it." },
    success: { available: "{{identifier}} is now available." },
    errors: { load: "Unable to load handling equipment.", release: "Unable to release the equipment." },
    dialog: { return: "Scan returned equipment" },
    diagnostics: { return: "Return equipment to park", view: "View handling equipment" }
  }
} as const;
